import { Component, DestroyRef, Input, ViewEncapsulation } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslateService } from '@ngx-translate/core';
import { TranslatedString } from 'lemunzo-api';
import { resolveTranslatedString } from '../../utils/resolve-translated-string';

@Component({
    selector: 'apcam-translation',
    templateUrl: './translation.component.html',
    encapsulation: ViewEncapsulation.None,
})
export class TranslationComponent {
    @Input()
    set model(value: TranslatedString | undefined | null) {
        if (value) {
            this.translatedString = value;
            this.translate();
        } else {
            this.translation = 'Unknown';
        }
    }

    translation: string = '';
    private translatedString: TranslatedString | null = null;

    constructor(
        private readonly destroyRef: DestroyRef,
        private readonly translateService: TranslateService
    ) {
        translateService.onLangChange
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe({ next: () => this.translate() });
    }

    private translate(): void {
        if (this.translatedString?.translations == null) return;

        this.translation = resolveTranslatedString(
            this.translatedString,
            this.translateService,
            {
                missingText: '<MISSING TEXT>',
            }
        )!;
    }
}
